import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import MovimentiTableRow from './MovimentiTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import ShowLocalNumber from '../ShowLocalNumber'
import PropTypes from 'prop-types';

class MovimentiTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    onExportClick(tipo){
        if (this.props.onExport !== undefined){
            this.props.onExport(tipo)
        }
    }

    onExportPerBudgetClick(format){
        
        if (this.props.onExport !== undefined){
            this.props.onExportPerBudget(format)
        }
    }

    render() {

        let sumCorrispettivo = 0.0
        let sumPagamento = 0.0
        let tableBody = this.props.items.map((item) => {
            if (item.entrUsc === 'E'){
                sumCorrispettivo += Number.parseFloat(item.corrispettivo);
                sumPagamento += Number.parseFloat(item.pagamento);
            }
            else
            {
                sumCorrispettivo -= Number.parseFloat(item.corrispettivo);
                sumPagamento -= Number.parseFloat(item.pagamento);
            }
            return <MovimentiTableRow movimento={item} key={item.idMovimento} onDeleteItem={this.props.onDeleteItem} onDocumentAction={this.props.onDocumentAction} readOnly={this.props.readOnly}/>
        })
        sumCorrispettivo = this.props.totalPrice.totaleCorrispettivo;
        sumPagamento = this.props.totalPrice.totalePagamento;
        let btnNuovo = null;
        if (this.props.readOnly == false){
            btnNuovo = (<Link to={`/app/movimenti/new`}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="plus icon"></i> Nuovo Movimento
                    </div>
                </Link>);
        }

        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
            <table className="ui striped sortable celled compact stackable table">
            <thead>
            <tr><th colSpan="15">
                {btnNuovo}
                <a href="#" onClick={(ev) => (this.onExportClick('csv'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file csv outline icon"></i> Esporta in CSV
                    </div>
                </a>
                <a href="#" onClick={(ev) => (this.onExportClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Esporta in Excel
                    </div>
                </a>
                <a href="#" onClick={(ev) => (this.onExportPerBudgetClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Esporta in Excel per Budget
                    </div>
                </a>

                {/*<PrintButton />*/}
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="m.idMovimento"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Id</TableColumnOrdered>
                <TableColumnOrdered
                    name="entrUsc"
                    orderActive={this.props.tableOrderingField === "entrUsc"}
                    orderFields="m.entrUsc"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Tipo</TableColumnOrdered>
                <TableColumnOrdered
                    name="data"
                    orderActive={this.props.tableOrderingField === "data"}
                    orderFields="m.data"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Data</TableColumnOrdered>
                <TableColumnOrdered
                    name="annoComp"
                    orderActive={this.props.tableOrderingField === "annoComp"}
                    orderFields="m.annoComp"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Anno</TableColumnOrdered>
                <TableColumnOrdered
                    name="prevDef"
                    orderActive={this.props.tableOrderingField === "prevDef"}
                    orderFields="m.prevDef"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >P/D</TableColumnOrdered>
                <TableColumnOrdered
                    name="dipNomeCompleto"
                    orderActive={this.props.tableOrderingField === "dipNomeCompleto"}
                    orderFields="p.catDesc,p.voxDesc,p.subDesc"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >PDC</TableColumnOrdered>
                <TableColumnOrdered
                    name="commessa"
                    orderActive={this.props.tableOrderingField === "commessa"}
                    orderFields="c.codice, c.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Commessa</TableColumnOrdered>
                <TableColumnOrdered
                    name="soggetto"
                    orderActive={this.props.tableOrderingField === "soggetto"}
                    orderFields="m.soggetto"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Soggetto</TableColumnOrdered>
                <TableColumnOrdered
                    name="estrConto"
                    orderActive={this.props.tableOrderingField === "estrConto"}
                    orderFields="m.estrConto"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Estratto Conto</TableColumnOrdered>
                <TableColumnOrdered
                    name="causale"
                    orderActive={this.props.tableOrderingField === "causale"}
                    orderFields="m.causale"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Causale</TableColumnOrdered>
                <TableColumnOrdered
                    name="forma"
                    orderActive={this.props.tableOrderingField === "forma"}
                    orderFields="m.forma"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Forma</TableColumnOrdered>
                <TableColumnOrdered
                    name="corrispettivo"
                    orderActive={this.props.tableOrderingField === "corrispettivo"}
                    orderFields="m.corrispettivo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Corrispettivo</TableColumnOrdered>
                <TableColumnOrdered
                    name="pagamento"
                    orderActive={this.props.tableOrderingField === "pagamento"}
                    orderFields="m.pagamento"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Pagamento</TableColumnOrdered>
                <th className="no-print" style={{textAlign: 'center'}}>Documento</th>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
                {tableBody}
            </tbody>
            <tfoot>
            <tr>
                <th className="right aligned" colSpan={11}>Totali</th>
                <th className="right aligned"><ShowLocalNumber value={sumCorrispettivo}/></th>
                <th className="right aligned"><ShowLocalNumber value={sumPagamento}/></th>
                <th></th>
                <th></th>
            </tr>
            </tfoot>
        </table>
            </div>
            </div>)
    }
}

MovimentiTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    totalPrice: PropTypes.object,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onDocumentAction: PropTypes.func,
    readOnly: PropTypes.bool
}
export default MovimentiTable;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiTable.js
 **/